import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { FidgetSpinner } from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { instrumentInfo, AccountExchangePairs } from "../utils/InstrumentInfo";
import "../App.css";

const ResultsTable = ({ formData, formSubmitted }) => {
  const [combinations, setCombinations] = useState([]);
  const [maxTotalLotSize, setMaxTotalLotSize] = useState();

  // Example usage:
  const rangeSize = formData.rangeSize; // Replace with the user's input
  const accountBalanceCurrency = formData.accountBalanceCurrency; // Replace with the user's input
  const tpPips = 200; // Replace with the user's input

  useEffect(() => {
    if (formSubmitted) {
      // Helper function to get the base currency of a cross pair
      const getBaseAndBalanceCurrencyRate = (baseCurrency, balanceCurrency) => {
        const newInstrument = balanceCurrency + "/" + baseCurrency;
        const { exchangeRate } = AccountExchangePairs[newInstrument];
        return exchangeRate;
      };

      const getBaseAndBalanceCurrencyRateNew = async (
        baseCurrency,
        balanceCurrency
      ) => {
        try {
          const apiKey = "6408e41e036ad7837f914b33bbc8cc36";
          const base = accountBalanceCurrency;
          const currencies = "EUR,XAU,XAG";

          const apiUrl = `https://api.metalpriceapi.com/v1/latest?api_key=${apiKey}&base=${base}&currencies=${currencies}`;

          const response = await fetch(apiUrl);

          if (!response.ok) {
            throw new Error(
              `MetalPrice API request failed with status ${response.status}`
            );
          }

          const data = await response.json();

          // Assuming the structure of the response is like: data.rates.<currency_code>
          return {
            EUR: 1 / data.rates.EUR,
            XAU: 1 / data.rates.XAU,
            XAG: 1 / data.rates.XAG,
          };
        } catch (err) {
          console.error("Error fetching exchange rate:", err);
          return null;
        }
      };

      // Function to calculate pip value
      const calculatePipValue = (instrument) => {
        const { contractSize, pipSize, currRate, isCrossPair, baseCurrency } =
          instrumentInfo[instrument];

        if (accountBalanceCurrency === baseCurrency) {
          // Formula for when account balance currency is the same as the base currency
          const pipValue = contractSize * pipSize;
          // console.log(
          //   "- (base currency == account balance currency) Pip Value: " +
          //     pipValue
          // );
          // const exchangeRate = getBaseAndBalanceCurrencyRateNew(
          //   baseCurrency,
          //   accountBalanceCurrency
          // );
          // console.log("exchnge rate: ", exchangeRate);
          return pipValue;
        } else {
          // Formula for when account balance currency is different from the base currency
          const exchangeRate = getBaseAndBalanceCurrencyRate(
            baseCurrency,
            accountBalanceCurrency
          );
          console.log("exchnge rate: ", exchangeRate);
          const pipValue = (contractSize * pipSize) / exchangeRate;
          console.log(
            "- (base currency != account balance currency) Pip Value: " +
              pipValue
          );
          return pipValue;
        }
      };

      // Function to calculate lot size
      const calculateLotSize = (instrument, riskAmount, rangeSizeInput) => {
        console.log(
          "Instrument:",
          instrument,
          " Risk Amount:",
          riskAmount,
          " Stop Loss Pips:",
          rangeSizeInput
        );
        const pipValue = calculatePipValue(instrument);
        const lotSize = riskAmount / (pipValue * rangeSizeInput);
        return lotSize;
      };

      // Function to calculate pipValue times rangeSize
      const calculatePVxRS = (instrument, rangeSizeInput) => {
        const pipValue = calculatePipValue(instrument);
        return pipValue * rangeSizeInput;
      };

      // Function to calculate pipValue times stepSize
      const calculatePVxSS = (instrument, stepSize) => {
        const pipValue = calculatePipValue(instrument);
        return pipValue * stepSize;
      };

      // Function to calculate the difference between the pip value times range size (RS)
      // and the pip value times step size (SS).
      const calculateRiskDifference = (
        instrument,
        rangeSizeInput,
        stepSize,
        indexTrade
      ) => {
        // Calculate the pip value times range size (PV * RS)
        const pvTimesRS = calculatePVxRS(instrument, rangeSizeInput);

        // Calculate the pip value times step size (PV * SS)
        const pvTimesSS = calculatePVxSS(instrument, stepSize);

        // Calculate the pip value times step size times the index of the trade (PV * SS * index)
        const stepRiskDiffSS = pvTimesSS * indexTrade;

        // Calculate and return the difference between PV * RS and PV * SS
        return pvTimesRS - stepRiskDiffSS;
      };

      // Function to calculate stepSize
      const calculateStepSize = (numTrades, rangeSize) => {
        return rangeSize / (numTrades - 1);
      };

      const calculateRiskAmount = () => {
        return formData.accountSize * (formData.riskPercentage / 100);
      };

      // Function to calculate PM for Buy
      const calculatePipMovementBuy = (
        rangeSize,
        numTrades,
        nthTrade,
        tpPips
      ) => {
        // nthTrade is the i^th trade ordered from first trade to last N^th-1 trade
        // numTrades is the total number of trades open
        const stepSize = calculateStepSize(numTrades, rangeSize);
        const tradePips = (nthTrade - 1) * stepSize; // from trade to range size

        const pm = 0;
        if (numTrades - 1 === nthTrade) {
          pm = tpPips; // pip movement from trade to TP
          return pm;
        }

        pm = tradePips - tpPips;

        return pm;
      };

      // Function to calculate PM for Sell
      const calculatePipMovementSell = (
        rangeSize,
        numTrades,
        nthTrade,
        tpPips
      ) => {
        // nthTrade is the i^th trade ordered from first trade to last N^th-1 trade
        // numTrades is the total number of trades open
        const stepSize = calculateStepSize(numTrades, rangeSize);
        const tradePips = (nthTrade - 1) * stepSize; // from trade to range size

        var pm = 0;
        if (numTrades - 1 === nthTrade) {
          pm = tpPips; // pip movement from trade to TP
          return pm;
        }

        pm = tradePips - tpPips;

        return pm;
      };

      const calculateTotalLotSizes = (desired_TL) => {
        const newCombinations = [];
        const errorInterval = 0.02;

        for (let N = 2; N < 12; N++) {
          for (let I = 0.1; I < 20; I += 0.01) {
            for (let F = 1.1; F <= 3; F += 0.01) {
              let TL = 0;
              let TP = 0;
              for (let i = 0; i <= N; i++) {
                TL += Math.pow(F, i) * I;
                // console.log("N:" + N + " I:"+ I + " F:" + F);
                // console.log("TL: " + TL);
                // console.log("TL: " + TL);
              }

              if (
                TL >= desired_TL - errorInterval &&
                TL <= desired_TL + errorInterval
              ) {
                // TP += Math.pow(F, i) * I * calculatePipMovementSell(200, N, tpPips);
                newCombinations.push({
                  I,
                  F,
                  N: N + 1,
                  TL,
                  TP: 0,
                  stepSize: 0,
                  // TP: calculateTotalProfits(tpPips, { I, F, N, TL }),
                  stepSize: calculateStepSize(N + 1, formData.rangeSize),
                });
              }
            }
          }
          // console.log("N: ", N);
        }
        // console.log("new combinations: ", newCombinations);
        setCombinations(newCombinations);
      };

      const calculateTotalLotSizesNew = (
        desired_TL,
        instrument,
        riskAmount,
        rangeSizeInput
      ) => {
        const newCombinations = [];
        const errorInterval = 0.02;
        const errorIntervalRisk = 50; // ie, $50
        const currentMagicNumber = 100; // to be changed

        for (let N = 2; N < 20; N++) {
          for (let I = 0.1; I < 3; I += 0.01) {
            for (let F = 1.1; F <= 3; F += 0.01) {
              let TL = 0;
              let CL = 0;
              let TP = 0;
              let TR = 0;
              for (let i = 0; i <= N; i++) {
                CL = Math.pow(F, i) * I;
                TL += Math.pow(F, i) * I;
                TR += CL * calculatePVxRS(instrument, rangeSizeInput);
                // console.log("N:" + N + " I:"+ I + " F:" + F);
                // console.log("TL: " + TL);
                // console.log("TR: $" + TR);
              }

              if (
                TR >= riskAmount - errorIntervalRisk &&
                TR <= riskAmount + errorIntervalRisk
              ) {
                // console.log("TR: " + TR);
                // console.log("riskAmount: " + riskAmount);
                // console.log("new combi: "+ {
                //   I,
                //   F,
                //   N: N + 1,
                //   TL,
                //   TP: 0,
                //   stepSize: 0,
                //   // TP: calculateTotalProfits(tpPips, { I, F, N, TL }),
                //   stepSize: calculateStepSize(N + 1, formData.rangeSize),
                // });
                // TP += Math.pow(F, i) * I * calculatePipMovementSell(200, N, tpPips);
                newCombinations.push({
                  I,
                  F,
                  N: N + 1,
                  TL,
                  TP: 0,
                  stepSize: 0,
                  // TP: calculateTotalProfits(tpPips, { I, F, N, TL }),
                  stepSize: calculateStepSize(N + 1, formData.rangeSize),
                });
              }
            }
          }
          // console.log("N: ", N);
        }
        console.log("new combinations: ", newCombinations);
        setCombinations(newCombinations);
      };

      const calculateTotalLotSizesV3 = (
        desired_TL,
        instrument,
        riskAmount,
        rangeSizeInput
      ) => {
        const newCombinations = [];
        const N = 10;
        const errorInterval = 0.02;
        const errorIntervalRisk = 50; // ie, $50
        const currentMagicNumber = 10; // to be changed

        for (let I = 0.1; I < 3; I += 0.1) {
          for (let F = 1.1; F <= 3; F += 0.1) {
            let stepSizeIncrement = 1;

            // Adjust stepSizeIncrement based on rangeSizeInput
            // if (rangeSizeInput <= 1000) {
            //   stepSizeIncrement = 1;
            // }else {
            //   stepSizeIncrement = rangeSizeInput/100;
            // }
            console.log("stepSize increment: ", stepSizeIncrement);
            for (let stepSize = 1; stepSize <= rangeSizeInput/currentMagicNumber; stepSize += stepSizeIncrement) {
              let TL = 0;
              let CL = 0;
              let CR = 0;
              let TP = 0;
              let TR = 0;

              let CRD = 0;
              let loopBroken = false;

              for (let i = 0; i <= N; i++) {
                CL = Math.pow(F, i) * I;
                TL += Math.pow(F, i) * I;
                CRD = calculateRiskDifference(
                  instrument,
                  rangeSizeInput/currentMagicNumber,
                  stepSize,
                  i
                );
                CR = CL * CRD;

                TR += CL * CRD;

                // Print the information for each iteration
                // console.log(
                //   `Trade ${i + 1}: I = ${I.toFixed(2)} - F = ${F.toFixed(
                //     2
                //   )} - StepSIZE = ${stepSize}, - stepSize * i = ${stepSize * i},
                //   Lot Size = ${CL.toFixed(2)},Total Lot Size = ${TL.toFixed(
                //     2
                //   )}, RiskDiff CRD = ${CRD},  Current Risk Amount = ${CR.toFixed(
                //     2
                //   )}, Total Risk = ${TR.toFixed(2)}`
                // );

                // Check if the total risk is already above 50% more than the risk amount
                if (TR >= 1.5 * riskAmount || CRD < 0) {
                  // console.log("BREAK LOOP, ALREADY TOO MUCH :) ");
                  loopBroken = true;
                  break; // Break out of the stepSize loop
                }
                // console.log(`\nAdditional Info: \n
                // calculatePVxRS(instrument, rangeSizeInput) = ${calculatePVxRS(
                //   instrument,
                //   rangeSizeInput
                // )},
                // calculateStepSize(N + 1, rangeSizeInput)*i = ${
                //   6.2 * calculateStepSize(N + 1, rangeSizeInput) * i
                // }`);

                // Check if the total risk calculated is smaller than the risk amount
                // set by the user.

                if (
                  TR >= riskAmount - errorIntervalRisk &&
                  TR <= riskAmount + errorIntervalRisk &&
                  !loopBroken
                ) {
                  if ((i + 1) * stepSize < rangeSizeInput/currentMagicNumber) {
                    // don't consider combinations where the risk amount can get
                    // triggered before reaching range size
                    // console.log("BREAK. STEP SIZE NOT ENOUGH :) ");
                    break;
                  } else {
                    newCombinations.push({
                      I,
                      F,
                      N: (rangeSizeInput / (stepSize*currentMagicNumber)).toFixed(0),
                      TL,
                      TP: 0,
                      // TP: calculateTotalProfits(tpPips, { I, F, N, TL }),
                      stepSize: currentMagicNumber*stepSize,
                    });
                  }
                }
              }
            }
          }
        }

        // console.log("new combinations: ", newCombinations);
        setCombinations(newCombinations);
      };

      const calculateTotalProfits = (tpPips, combination) => {
        let TP = 0;

        for (let i = 0; i <= combination.N; i++) {
          const tradeProfit =
            Math.pow(combination.F, i) *
            combination.I *
            calculatePipMovementSell(rangeSize, combination.N, i, tpPips);
          console.log("trade " + i + " has $" + tradeProfit + " profits ");
          TP += tradeProfit;
          // console.log("N:" + N + " I:"+ I + " F:" + F);
          // console.log("TL: " + TL);
        }
        console.log("Total profits: " + TP);
        return TP;
      };

      const testCombination = (I, F, N, instrument, rangeSizeInput) => {
        let TL = 0;
        let CL = 0;
        let CR = 0;
        let TP = 0;
        let TR = 0;
        for (let i = 0; i <= N; i++) {
          CL = Math.pow(F, i) * I;
          TL += Math.pow(F, i) * I;
          CR =
            CL *
            (calculatePVxRS(instrument, rangeSizeInput) -
              6.2 * calculateStepSize(N + 1, rangeSizeInput) * i);
          TR +=
            CL *
            (calculatePVxRS(instrument, rangeSizeInput) -
              6.2 * calculateStepSize(N + 1, rangeSizeInput) * i);

          // Print the information for each iteration
          // console.log(
          //   `Trade ${i + 1}: Lot Size = ${CL.toFixed(
          //     2
          //   )},Total Lot Size = ${TL.toFixed(2)}, Risk = ${calculatePVxRS(
          //     instrument,
          //     rangeSizeInput
          //   ).toFixed(2)},  Current Risk Amount = ${CR.toFixed(
          //     2
          //   )}, Total Risk = ${TR.toFixed(2)}`
          // );
          // console.log(`\nAdditional Info: \n
          // calculatePVxRS(instrument, rangeSizeInput) = ${calculatePVxRS(
          //   instrument,
          //   rangeSizeInput
          // )},
          // calculateStepSize(N + 1, rangeSizeInput)*i = ${
          //   6.2 * calculateStepSize(N + 1, rangeSizeInput) * i
          // }`);
        }

        return 0;
      };

      const lotCalc = calculateLotSize(
        formData.currencyPair,
        calculateRiskAmount(),
        formData.rangeSize
      );
      setMaxTotalLotSize(lotCalc);
      console.log("total lot size needed is: " + lotCalc);
      // calculateTotalLotSizes(lotCalc);
      // calculateTotalLotSizesNew(
      //   lotCalc,
      //   formData.currencyPair,
      //   calculateRiskAmount(),
      //   formData.rangeSize
      // );
      calculateTotalLotSizesV3(
        lotCalc,
        formData.currencyPair,
        calculateRiskAmount(),
        formData.rangeSize
      );

      // testCombination(0.12, 1.11, 18, formData.currencyPair, 50);
    }
  }, [formData, formSubmitted]); // Note: Dependency array is empty to run the effect only once

  // Function to toggle the visibility of individual combinations
  const toggleRow = (N) => {
    const updatedCombinations = combinations.map((combo) =>
      combo.N === N
        ? { ...combo, visible: !combo.visible }
        : { ...combo, visible: false }
    );
    setCombinations(updatedCombinations);
  };

  return (
    <Row className="result-container">
      <Col>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2>Results</h2>
        </div>
        <table className="results-table">
          <thead>
            <tr>
              <th>Initial Lot Size</th>
              <th>Grid Increment Factor</th>
              <th># of Trades</th>
              <th>Total Lot Size</th>
              <th>Potential Total Profits</th>
              <th>Step Size</th>
            </tr>
          </thead>
          <tbody>
            {combinations.map((combination, index) => (
              <React.Fragment key={index}>
                {index === 0 || combinations[index - 1].N !== combination.N ? (
                  <tr onClick={() => toggleRow(combination.N)}>
                    <th colSpan="6">
                      Max Total Lot size = {maxTotalLotSize} | Max # trades ={" "}
                      {combination.N} | Step Size ={" "}
                      {combination.stepSize.toFixed(2)}
                    </th>
                  </tr>
                ) : null}
                <tr onClick={() => toggleRow(combination.N)}>
                  <td>{combination.I.toFixed(2)}</td>
                  <td>{combination.F.toFixed(2)}</td>
                  <td>{combination.N}</td>
                  <td>{combination.TL.toFixed(2)}</td>
                  {/* <td>{combination.TP.toFixed(2)}</td> */}
                  <td>-</td>
                  <td>{combination.stepSize.toFixed(2)}</td>
                </tr>
                {combination.visible && (
                  <tr>
                    <td colSpan="6">
                      This strategy will make {combination.N} trade(s) before
                      reaching your risk amount. With a fixed lot of{" "}
                      {combination.I.toFixed(2)}, a step size of{" "}
                      {combination.stepSize.toFixed(2)}, and a grid increment
                      factor equal to {combination.F.toFixed(2)}.
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </Col>
    </Row>
  );
};

export default ResultsTable;
